import { authApiService } from './authService';
export const humanFeedbackService = {

  submitHumanFeedbackOnAIGeneratedSoapNote: async (soapNoteId, section, rating, feedbackText, feedbackData = null) => {
    const payload = { 
      section,
      feedback: rating,
      userExplanation: feedbackText
    };

    if (feedbackData) {
      payload.feedbackType = feedbackData.feedbackType;
      payload.contentType = feedbackData.contentType;
      payload.timestamp = feedbackData.timestamp;

      if (feedbackData.feedbackType === "global-level") {
        payload.reportedContent = "";
      } else {
        payload.reportedContent = feedbackData.reportedContent || "";
      }
    }

    return authApiService.post(`/feedback/section/${soapNoteId}`, payload);
  },

  getUserFeedbackState: async (soapNoteId) => {
    return authApiService.get(`/feedback/state/${soapNoteId}`);
  },

  incrementSectionVersion: async (soapNoteId, section, content, editReason = 'manual_edit') => {
    return authApiService.post(`/section-versions/increment/${soapNoteId}/${section}`, {
      content,
      editReason
    });
  },

  getSectionVersions: async (soapNoteId) => {
    return authApiService.get(`/section-versions/versions/${soapNoteId}`);
  },

  getSectionFeedbackHistory: async (soapNoteId, section, version = null) => {
    const params = version ? { version } : {};
    return authApiService.get(`/feedback/history/${soapNoteId}/${section}`, { params });
  },

  // New methods for version history and diff viewing
  getSectionVersionHistory: async (soapNoteId, section) => {
    return authApiService.get(`/section-versions/history/${soapNoteId}/${section}`);
  },

  getSectionVersionByNumber: async (soapNoteId, section, version) => {
    return authApiService.get(`/section-versions/version/${soapNoteId}/${section}/${version}`);
  },

  compareSectionVersions: async (soapNoteId, section, version1, version2) => {
    return authApiService.get(`/section-versions/compare/${soapNoteId}/${section}`, {
      params: { version1, version2 }
    });
  },

  getAllVersionDiffs: async (soapNoteId, section) => {
    return authApiService.get(`/section-versions/diffs/${soapNoteId}/${section}`);
  },

  // Restore and retrieve operations
  restoreSectionVersion: async (soapNoteId, section, version, editReason = 'version_restore') => {
    return authApiService.post(`/section-versions/restore/${soapNoteId}/${section}`, {
      version,
      editReason
    });
  },

  getAllSectionsContentByVersion: async (soapNoteId, version) => {
    return authApiService.get(`/section-versions/all-sections/${soapNoteId}/${version}`);
  }

}